import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { ThemeOverrider } from '../../../themes/ThemeOverrider/ThemeOverrider'
import { OlympicWidgetHeading } from '../OlympicWidgetHeading/OlympicWidgetHeading'
import { OlympicWidgetLinks } from '../OlympicWidgetLinks/OlympicwidgetLinks'
import {
    StyledOlympicWidgetWrap,
    StyledWidgetRow,
} from './OlympicWidgetWrap.styled'

export interface OlympicWidgetWrapProps {
    isFullSize: boolean
    children?: JSX.Element
}
export function OlympicWidgetWrap(props: OlympicWidgetWrapProps) {
    const [pageType, setPageType] = useState<string>('')
    const location = useLocation()

    useEffect(() => {
        const currentPageType = location.pathname.split('/')[3]
        if (currentPageType !== undefined) {
            setPageType(currentPageType)
        }
    }, [location.pathname])

    const { isFullSize, children } = props

    return (
        <ThemeOverrider override="tokyo">
            <StyledOlympicWidgetWrap isFullSize={isFullSize}>
                <section className="medalTally__heading-row">
                    <OlympicWidgetHeading
                        isFullSize={isFullSize}
                        pageType={pageType}
                    />
                </section>

                <StyledWidgetRow isFullSize={isFullSize}>
                    {children}
                </StyledWidgetRow>

                <section className="medalTally__link-row">
                    <OlympicWidgetLinks
                        isFullSize={isFullSize}
                        pageType={pageType}
                    />
                </section>
            </StyledOlympicWidgetWrap>
        </ThemeOverrider>
    )
}

OlympicWidgetWrap.displayName = 'OlympicWidgetWrap'
